import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Travelsagentsinpune() {



const cardData = {
  keyword: "Travel Agents in Pune",
  heading: "Lotus Cab: Travel Agents in Pune",

  headingDescription:
    "Lotus Cab operates as one of the trusted Travel Agents in Pune offering complete tour planning and transportation services under one roof. Whether you are looking for domestic holiday packages, international tours, honeymoon trips, or corporate travel management, we provide customized itineraries tailored to your needs. Our team assists with flight booking, hotel reservations, visa support, and comfortable taxi services. With strong vendor partnerships and transparent pricing, we ensure budget-friendly yet premium travel experiences. We focus on customer satisfaction, timely coordination, and stress-free planning. From Pune city departures to nationwide and global destinations, we make every journey smooth and memorable.",

  top: "Top Travel Destinations from Pune with Lotus Cab",

  topPlaces: [
    {
      title: "Goa",
      description:
        "Goa is one of the most popular holiday destinations from Pune. Known for beaches, nightlife, and Portuguese heritage, it attracts families and couples alike. Travel agents assist with hotel bookings and sightseeing plans. Honeymoon and group packages are widely booked. Both flight and road travel options are available. It remains a top domestic tour package from Pune."
    },
    {
      title: "Kerala",
      description:
        "Kerala offers backwaters, houseboats, and scenic hill stations. It is ideal for honeymoon and family vacations. Travel agents provide complete package planning including flights and hotels. Sightseeing tours are customized as per itinerary. Safe and comfortable travel arrangements are ensured. It is a premium domestic tour choice."
    },
    {
      title: "Kashmir",
      description:
        "Kashmir is known as Paradise on Earth. Snow-capped mountains and Dal Lake attract tourists. Tour operators arrange guided sightseeing tours. Family and honeymoon packages are popular. Flight booking and hotel coordination are included. It is one of the most requested holiday packages."
    },
    {
      title: "Dubai",
      description:
        "Dubai is a preferred international tour destination from Pune. It offers desert safaris, luxury shopping, and Burj Khalifa visits. Travel agencies manage visa assistance and hotel bookings. Corporate and family trips are common. International package customization available. Premium travel experience guaranteed."
    },
    {
      title: "Singapore",
      description:
        "Singapore is ideal for family-friendly international tours. Attractions include Universal Studios and Sentosa Island. Travel agents handle visa processing and flights. Guided tours are included in packages. Hotel and airport transfers arranged smoothly. Popular global holiday destination."
    },
    {
      title: "Andaman Islands",
      description:
        "Andaman Islands offer crystal-clear beaches and water activities. Honeymoon couples frequently book this destination. Travel agents coordinate flights and resort stays. Adventure packages available. Safe travel planning ensured. Ideal tropical getaway."
    },
    {
      title: "Rajasthan",
      description:
        "Rajasthan is known for palaces and desert safaris. Jaipur, Udaipur, and Jaisalmer are popular cities. Domestic tour packages are widely booked. Heritage hotel stays included. Cultural tours arranged. Suitable for family and group travel."
    },
    {
      title: "Europe Tour",
      description:
        "Europe multi-country tours are popular international packages. Travel agencies manage visa and flight arrangements. Guided sightseeing included. Group departures available. Customized luxury travel packages provided. Premium international experience ensured."
    }
  ],

  services: [
    {
      name: "Best Tour Operators Pune",
      description:
        "Professional tour operators offering customized domestic and international travel packages. Expert itinerary planning provided. Transparent pricing maintained. Suitable for family and corporate travel. End-to-end travel coordination ensured."
    },
    {
      name: "Holiday Packages from Pune",
      description:
        "Customized holiday packages for domestic and international destinations. Flight, hotel, and sightseeing included. Budget and luxury options available. Flexible travel dates supported. Hassle-free travel planning ensured."
    },
    {
      name: "Domestic Tour Packages Pune",
      description:
        "Complete domestic travel planning from Pune to major Indian destinations. Hotel bookings and transfers included. Group and honeymoon packages available. Transparent package pricing provided. Comfortable travel arrangements ensured."
    },
    {
      name: "International Tour Packages Pune",
      description:
        "International tour packages including visa assistance and flight booking. Guided sightseeing included. Customized travel plans available. Luxury and budget options supported. Safe and organized travel experience guaranteed."
    },
    {
      name: "Corporate Travel Agency Pune",
      description:
        "Professional corporate travel management services. Flight and hotel booking support provided. Timely coordination ensured. Transparent billing maintained. Suitable for business trips and conferences."
    },
    {
      name: "Flight Booking Agents Pune",
      description:
        "Domestic and international flight booking services available. Best airfare deals provided. Flexible cancellation support included. Quick confirmation ensured. Reliable travel assistance guaranteed."
    },
    {
      name: "Hotel Booking Service Pune",
      description:
        "Affordable and luxury hotel booking assistance. Verified property listings provided. Flexible stay options available. Transparent pricing maintained. Comfortable accommodation guaranteed."
    },
    {
      name: "Taxi and Tour Package Pune",
      description:
        "Combined taxi and tour package service for seamless travel. Local sightseeing cab included. Airport and outstation transfers arranged. Transparent pricing provided. Complete travel solution ensured."
    }
  ],

  tableData: [
    ["Travel Agents in Pune", "Best Tour Operators Pune"],
    ["Pune Travel Agency", "Holiday Packages from Pune"],
    ["Domestic Tour Packages Pune", "International Tour Packages Pune"],
    ["Honeymoon Packages Pune", "Corporate Travel Agency Pune"],
    ["Group Tour Booking Pune", "Flight Booking Agents Pune"],
    ["Hotel Booking Service Pune", "Taxi and Tour Package Pune"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Customized Travel Planning",
      WhyChoosedescription:
        "Personalized itineraries based on budget and preferences. Flexible scheduling supported."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription:
        "Clear cost breakdown with no hidden charges. Honest billing policy followed."
    },
    {
      WhyChooseheading: "Domestic & International Expertise",
      WhyChoosedescription:
        "Expertise in both Indian and global destinations. Professional coordination ensured."
    },
    {
      WhyChooseheading: "Corporate Travel Management",
      WhyChoosedescription:
        "Specialized services for business travel and conferences. Timely planning guaranteed."
    },
    {
      WhyChooseheading: "Complete Travel Assistance",
      WhyChoosedescription:
        "Flight, hotel, visa, and taxi arranged under one roof."
    },
    {
      WhyChooseheading: "24/7 Customer Support",
      WhyChoosedescription:
        "Round-the-clock assistance during travel planning and trip execution."
    },
    {
      WhyChooseheading: "Group & Family Friendly Packages",
      WhyChoosedescription:
        "Tailored packages for family vacations and group tours."
    },
    {
      WhyChooseheading: "Reliable & Trusted Service",
      WhyChoosedescription:
        "On-time coordination and seamless travel experience ensured."
    }
  ]
};

const faqData = [
  { question: "Do you provide international tour packages?", answer: "Yes, we provide customized international tour packages including visa and flight assistance." },
  { question: "Can I book domestic holiday packages?", answer: "Yes, domestic holiday packages from Pune are available for major Indian destinations." },
  { question: "Do you assist with visa processing?", answer: "Yes, visa guidance and assistance are provided for international travel." },
  { question: "Are honeymoon packages available?", answer: "Yes, special honeymoon packages are available with customized planning." },
  { question: "Do you offer corporate travel services?", answer: "Yes, corporate travel planning and booking services are available." },
  { question: "Is flight booking service available?", answer: "Yes, domestic and international flight booking support is provided." },
  { question: "Can I book group tours?", answer: "Yes, group tour booking options are available." },
  { question: "Do you provide hotel booking assistance?", answer: "Yes, hotel booking service is available for domestic and international stays." },
  { question: "Is online booking available?", answer: "Yes, booking assistance is available online and via phone." },
  { question: "Are travel packages customizable?", answer: "Yes, travel packages are fully customizable based on preferences and budget." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Joshi",
    feedback:
      "Booked Kerala holiday package through Lotus Cab team. Entire travel planning was smooth and professional. Hotel and sightseeing arrangements were excellent.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Sharma",
    feedback:
      "International Dubai tour was perfectly managed. Visa, flights, and hotel bookings were seamless. Highly satisfied with service.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Aniket Patil",
    feedback:
      "Corporate travel booking for our team was handled professionally. Timely coordination and transparent pricing impressed us.",
    rating: 5
  }
];


























































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Travel Agents in Pune",
  "image": "https://lotuscab.com/assets/images/travel-agents-pune.jpg", 
  "description": "Lotus Cab offers travel agency services in Pune including domestic and international tour packages, honeymoon trips, corporate travel, group tours, flight and hotel bookings, and combined taxi-tour packages. Book convenient and affordable travel services with professional assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "5200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "500",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/travel-agents-pune"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Travel Agents in Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book travel services in Pune with Lotus Cab. Domestic & international tours, honeymoon, corporate travel, group tours, flight & hotel bookings. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Travel Agents in Pune, Best Tour Operators Pune, Pune Travel Agency, Holiday Packages from Pune, Domestic Tour Packages Pune, International Tour Packages Pune, Honeymoon Packages Pune, Corporate Travel Agency Pune, Group Tour Booking Pune, Flight Booking Agents Pune, Hotel Booking Service Pune, Taxi and Tour Package Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/23.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Travelsagentsinpune;